module.exports = __webpack_public_path__ + "img/i-roles-6.cf52ce96.png";